import { api } from './api';

export const adminService = {
  // --- Dashboard ---
  getDashboardSummary: () => api.get('/admin/dashboard/summary'),

  getDashboardComparison: ({ page = 1, limit = 10 } = {}) =>
    api.get('/admin/dashboard/comparison', { params: { page, limit } }),

  getDashboardUniformSummary: ({ period, uniform_id, uniform_ids, wilayah, company_id } = {}) =>
    api.get('/admin/dashboard/uniform-summary', { params: { period, uniform_id, uniform_ids, wilayah, company_id } }),

  getDashboardUniformPivot: ({ period, uniform_id, uniform_ids, wilayah, company_id } = {}) =>
    api.get('/admin/dashboard/uniform-pivot', { params: { period, uniform_id, uniform_ids, wilayah, company_id } }),

  // --- Companies (Superadmin Only) ---
  getCompanies: ({ page = 1, limit = 10 } = {}) =>
    api.get('/admin/companies', { params: { page, limit } }),

  createCompany: (data) => api.post('/admin/companies', data),

  getCompanyById: (companyId) => api.get(`/admin/companies/${companyId}`),

  updateCompany: (companyId, data) => api.put(`/admin/companies/${companyId}`, data),

  // --- Users CRUD ---
  getUsers: ({ page = 1, limit = 10, role, search } = {}) =>
    api.get('/admin/users', { params: { page, limit, role, search } }),

  createUser: (data) => api.post('/admin/users', data),

  getUserById: (userId) => api.get(`/admin/users/${userId}`),

  updateUser: (userId, data) => api.put(`/admin/users/${userId}`, data),

  // --- Uniform Categories CRUD ---
  getUniformCategories: ({ page = 1, limit = 10, company_id, search } = {}) =>
    api.get('/admin/uniform-categories', { params: { page, limit, company_id, search } }),

  createUniformCategory: (data) => api.post('/admin/uniform-categories', data),

  getUniformCategoryById: (categoryId) => api.get(`/admin/uniform-categories/${categoryId}`),

  updateUniformCategory: (categoryId, data) => api.put(`/admin/uniform-categories/${categoryId}`, data),

  deleteUniformCategory: (categoryId) => api.delete(`/admin/uniform-categories/${categoryId}`),

  // --- Uniforms CRUD ---
  getUniforms: ({ page = 1, limit = 10, company_id, search } = {}) =>
    api.get('/admin/uniforms', { params: { page, limit, company_id, search } }),

  createUniform: (data) => api.post('/admin/uniforms', data),

  getUniformById: (uniformId) => api.get(`/admin/uniforms/${uniformId}`),

  updateUniform: (uniformId, data) => api.put(`/admin/uniforms/${uniformId}`, data),

  deleteUniform: (uniformId) => api.delete(`/admin/uniforms/${uniformId}`),

  // --- Uniform Reports ---
  getReports: ({ page = 1, limit = 10, report_status, period, wilayah, company_id, search } = {}) =>
    api.get('/admin/uniform-reports', { params: { page, limit, report_status, period, wilayah, company_id, search } }),

  getMissingEmployees: ({ page = 1, limit = 10, period, wilayah, company_id, search } = {}) =>
    api.get('/admin/uniform-reports/missing-employees', { params: { page, limit, period, wilayah, company_id, search } }),

  getUniformComparisonByUser: (userId, { period } = {}) =>
    api.get(`/admin/users/${userId}/uniform-comparison`, { params: { period } }),

  getReportById: (reportId) => api.get(`/admin/uniform-reports/${reportId}`),

  createReport: (data) => api.post('/admin/uniform-reports', data),

  updateReport: (reportId, updates) => api.put(`/admin/uniform-reports/${reportId}`, updates),

  deleteReport: (reportId) => api.delete(`/admin/uniform-reports/${reportId}`),

  bulkDeleteReports: (reportIds) => api.post('/admin/uniform-reports/bulk-delete', {
    uniform_report_ids: reportIds,
  }),

  getReportDetails: (reportId, { page = 1, limit = 10 } = {}) =>
    api.get(`/admin/uniform-reports/${reportId}/details`, { params: { page, limit } }),

  // --- Report Details CRUD (Admin) ---
  addReportDetail: (reportId, data) => api.post(`/admin/uniform-reports/${reportId}/details`, data),

  updateReportDetail: (detailId, data) => api.put(`/admin/uniform-report-details/${detailId}`, data),

  deleteReportDetail: (detailId) => api.delete(`/admin/uniform-report-details/${detailId}`),

  // --- Export Reports ---
  getReportExcel: ({ period, company_id } = {}) =>
    api.getBlob('/admin/reports/uniform-report/excel', { params: { period, company_id } }),

  getUniformPivotExcelUrl: ({ period, company_id } = {}) =>
    api.get('/admin/reports/uniform-report/pivot-excel', { params: { period, company_id } }),

  getComparisonReport: ({ period, page = 1, limit = 10, company_id } = {}) =>
    api.get('/admin/reports/uniform-report/comparison', { params: { period, page, limit, company_id } }),
};

